import type { ExtractPublicPropTypes } from 'vue'
import { buttonsProps } from '@el-plus/components/buttons'

export const titleProps = {
  // 右侧按钮
  buttons: {
    ...buttonsProps.list,
  },
  // 标题名称
  title: String,
  // 是否显示展开折叠
  showDownUp: {
    type: Boolean,
    default: false,
  },
} as const
export type TitleProps = ExtractPublicPropTypes<typeof titleProps>
export const titleEmits = {
  toggle: (expanded: boolean) => true,
}
export type TitleEmits = typeof titleEmits
